import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../api";
import FormBuilderAdmin from "components/formbuilder/admin/FormBuilderAdmin";
export default function AdminPageFormalitiesTemplateBuilder() {
  const { tplId } = useParams();

  const defaultSchema = {
    $schema: "https://json-schema.org/draft/2020-12/schema",
    type: "object",
    title: "Formulaire",
    properties: {}
  };
  const [template, setTemplate] = useState(null);
  const [schema, setSchema] = useState(null);
  const [loading, setLoading] = useState(true);
  // -------------------------------------------------------------
  // LOAD TEMPLATE
  // -------------------------------------------------------------
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await api.get(
          `/admin/formalities/template/${tplId}`
        );

        const tpl = res.data;
        if (!tpl?.ftId) {
          throw new Error("Template invalide");
        }

        setTemplate(tpl);
        setSchema(tpl.format?.schema || defaultSchema);

      } catch (err) {
        console.error(err);
        Swal.fire(
          "Erreur",
          "Impossible de charger le template.",
          "error"
        );
        setSchema(defaultSchema);
      } finally {
        setLoading(false);
      }
    })();
  }, [tplId]);

  // -------------------------------------------------------------
  // SAVE SCHEMA
  // -------------------------------------------------------------
  const handleSaveSchema = async (newSchema) => {
    try {
      await api.put(
        `/admin/formalities/template/${tplId}`,
        { schema: newSchema }
      );
      setSchema(newSchema);
    } catch (err) {
      console.error(err);
      Swal.fire("Erreur", err.message, "error");
    }
  };

  // -------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------
  if (loading || !schema) {
    return <div className="p-4">Chargement…</div>;
  }

  return (
    <div className="container-fluid bg-white ps-0 pe-lg-5">
      <div id="fb-menu-root"></div>
      <FormBuilderAdmin
        initialSchema={schema}
        meta={template}
        onSave={handleSaveSchema}
      />
    </div>
  );
}